import { Checkbox as muiCheckbox } from '@mui/material'
import styled from 'styled-components'

import { COLORS } from '../Colors'

type CheckboxProps = {
    checked: boolean
    onChange: (event: any) => void
    value: string
    disabled?: boolean
}

export default function CheckboxComponent({
    checked,
    onChange,
    value,
    disabled,
}: CheckboxProps): JSX.Element {
    return (
        <BasicCheckbox
            disabled={disabled}
            checked={checked}
            onChange={onChange}
            value={value}
            sx={{ padding: 0 }}
        />
    )
}

const BasicCheckbox = styled(muiCheckbox)`
    & > svg {
        color: ${(props) =>
            props.checked ? COLORS.primaryOrange : COLORS.lightBlueGrey};
    }
    cursor: ${(props) => (props.disabled ? 'cursor' : 'pointer')};
    opacity: ${(props) => (props.disabled ? 0.5 : 1)};
`
